// extracted by mini-css-extract-plugin
module.exports = {"cardCountTitle":"StatisticInLine_cardCountTitle__2IX_D","cardCountNumber":"StatisticInLine_cardCountNumber__3M_Hg","cardCountSuffix":"StatisticInLine_cardCountSuffix__2TroY"};